import React from "react";
import AdFoxAdaptive from "../components/AdFoxAdaptive";

export default function AdFoxTGB5({ context }) {

    return (
        <div className="social-desktop">
            <AdFoxAdaptive
                options={[
                    {
                        ownerId: 284551,
                        containerId: "adfox_1570171516840223198443590",
                        params: {
                            pp: 'g',
                            ps: 'dmmq',
                            p2: 'haws'
                        }
                    },
                    ["desktop", "tablet"],
                    {
                        tabletWidth: 830,
                        phoneWidth: 480,
                        isAutoReloads: false
                    }
                ]}
            />
        </div>
    );
}
